
import {
  getCityList
} from "@/views/local/js/api";
export default{
    state : {
        regionData:[],
        orderInfo:[],
    },
    mutations: {
      SET_REGION(state,data){
        state.regionData  = data;
      },
      SET_ORDER(state,data){
        state.orderInfo  = data;
      }
    },
    actions: {
      /* 获取区域信息 */
      getRegionList({commit, state}) {
        return new Promise(async (resolve,reject)=>{
            if(!state.regionData||!state.regionData.length){
              let {result=[]}  = await getCityList();
              commit('SET_REGION',result);
            }
            resolve(state.regionData)
        })
      },
  
    },
}

